import React, { useState, useRef, useEffect } from 'react';

// ==========================================
// IDENTIFICADOR TECNICO SQLEXEC  (#idsqlexec · component_form)
// Componente de presentacion puro: sin consultas ni reglas de negocio.
// Formato y estilos llegan por props desde sisconfig.panel_ui.identificador
// (el componente padre es quien lee useSisConfig). Solo se dibuja con
// config.visible === true. Si falta idsqlexec muestra solo component_form,
// sin simbolos sobrantes. Un clic copia el texto mostrado al portapapeles.
// Se renderiza como texto (React escapa el contenido), nunca como HTML.
// ==========================================

// navigator.clipboard solo existe en contexto seguro (https/localhost);
// fuera de el se usa el respaldo con textarea + execCommand('copy').
const copiarTexto = async (texto) => {
  try {
    if (window.isSecureContext && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch (e) {
    // continua con el respaldo
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = texto;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
};

const SqlexecIdTag = ({ idsqlexec, componentForm, config }) => {
  const [hover, setHover] = useState(false);
  const [copiado, setCopiado] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  if (config?.visible !== true || !componentForm) return null;

  const tieneId = idsqlexec !== null && idsqlexec !== undefined && idsqlexec !== '';
  const texto = tieneId
    ? (config.format || '#{id} · {form}')
        .replace('{id}', String(idsqlexec))
        .replace('{form}', String(componentForm))
    : String(componentForm);
  const mostrado = copiado
    ? (config.copiedLabel || '{texto}').replace('{texto}', texto)
    : texto;

  const handleClick = async (e) => {
    e.stopPropagation();
    if (await copiarTexto(texto)) {
      setCopiado(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopiado(false), config.copiedMs || 1500);
    }
  };

  return (
    <span
      role="button"
      tabIndex={0}
      title={texto}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(e); }
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        fontSize:   config.fontSize || '0.65rem',
        fontFamily: config.fontFamily || 'inherit',
        color:      hover ? (config.hoverTextColor || config.textColor || 'inherit') : (config.textColor || 'inherit'),
        cursor:     'pointer',
        whiteSpace: 'nowrap',
        display:    'inline-block'
      }}
    >
      {mostrado}
    </span>
  );
};

export default SqlexecIdTag;
